<template>
  <div class="drawer">
    <div class="drawer-container">
      <div class="drawer-content with-footer">
        <el-form
          class="box"
          ref="salesTargetForm"
          :model="salesTarget"
          label-width="90px"
        >
          <fieldset class="mgb15">
            <legend>{{ $t("text.baseInfo") }}</legend>
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('salesTarget.month')">{{
                  salesTarget.month
                }}</el-form-item>
              </el-col>
            </el-row>
          </fieldset>
          <fieldset class="mgb15">
            <legend>{{ $t("salesTarget.detailInfo") }}</legend>
            <vxe-table
              :data="salesTarget.salesTargetItems"
              size="mini"
              border
              :scroll-y="{ enabled: false }"
            >
              <vxe-table-column
                field="userName"
                :title="$t('salesTarget.userName')"
              ></vxe-table-column>
              <vxe-table-column
                field="target"
                :title="$t('salesTarget.target')"
              >
                <template v-slot="{ row }">
                  <el-input size="small" v-model.trim="row.target">
                    <template slot="prepend">
                      <currency :code="salesTarget.currency"></currency>
                    </template>
                  </el-input>
                </template>
              </vxe-table-column>
            </vxe-table>
          </fieldset>
        </el-form>
      </div>
    </div>
    <div class="drawer-footer">
      <el-button
        type="primary"
        size="small"
        plain
        :loading="saveDoing"
        @click="saveSubmit"
        >{{ $t("text.submit") }}</el-button
      >
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { page } from "@/utils/mixins.js";
import Currency from "@/components/Currency";

import Util from "@/utils/index.js";
import SalesTarget from "@/api/salesTarget.js";
import SalesTargetItem from "@/api/salesTargetItem.js";
import User from "@/api/user.js";

export default {
  props: {
    id: Number,
  },
  mixins: [page],
  components: { Currency },
  data() {
    return {
      Util: Util,
      salesTarget: {
        month: null,
        salesTargetItems: [],
      },
      salesTargetItems: [],
      users: [],
      saveDoing: false,
    };
  },
  created() {
    const self = this;
    self.loadingStart();
    axios
      .all([
        SalesTarget.findById({ id: self.id }),
        SalesTargetItem.findBySalesTargetId({
          salesTargetId: self.id,
        }),
        User.findByTenantId(self.Permit.currentTenant().id),
      ])
      .then(
        axios.spread(function (salesTarget, salesTargetItems, users) {
          if (salesTarget.data.code === 200) {
            self.salesTarget = salesTarget.data.entity;
            self.loadingEnd();
          } else {
            self.sysError();
          }
          if (salesTargetItems.status === 200) {
            self.salesTargetItems = salesTargetItems.data;
          } else {
            self.sysError();
          }
          self.users = users.data.filter(
            (u) => u.authorize === true && u.voidAt == null
          );
          self.salesTarget.salesTargetItems = [];
          for (const u of self.users) {
            const existUser = self.salesTargetItems.find(
              (s) => s.userId === u.id
            );
            const obj = {
              id: existUser != null ? existUser.id : null,
              salesTargetId: salesTarget.data.entity.id,
              userId: u.id,
              userName: u.name,
              target: existUser != null ? existUser.target : null,
              month: null,
            };
            self.salesTarget.salesTargetItems.push(obj);
          }
        })
      );
  },
  methods: {
    saveSubmit(type) {
      const self = this;
      this.$refs.salesTargetForm.validate((valid) => {
        if (valid) {
          self.saveDoing = true;
          if (self.salesTarget.salesTargetItems.length === 0) {
            self.$message({
              message: self.$t("prompt.atLeastOneData"),
              type: "warning",
            });
          }
          for (const i of self.salesTarget.salesTargetItems) {
            i.month = Util.formatDateYM(self.salesTarget.month);
          }
          self.saveDoing = true;
          SalesTargetItem.updateBatch(self.salesTarget.salesTargetItems).then(
            function (res) {
              self.saveDoing = false;
              if (res.status === 200) {
                self.$message({
                  message: self.$t("prompt.editSuccess"),
                  type: "success",
                });
                self.$emit("updateData");
              } else {
                self.sysError();
              }
            }
          );
        } else {
          return false;
        }
      });
    },
  },
};
</script>